import { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";

/**
 * Global unread inbound messages (respects RLS). Excludes archived conversations.
 * Live-updates via Realtime.
 */
export function useUnreadInboxCount() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      try {
        const { data: total, error } = await supabase.rpc("count_unread_inbox_messages");
        if (!cancelled) {
          if (!error && total != null) {
            setCount(Number(total));
          } else {
            const { count: c } = await supabase
              .from("chat_messages")
              .select("id", { count: "exact", head: true })
              .eq("direction", "inbound")
              .is("read_at", null);
            setCount(c || 0);
            if (error) console.warn("[useUnreadInboxCount] RPC fallback:", error.message);
          }
        }
      } catch {
        if (!cancelled) setCount(0);
      }
    }

    load();

    const channel = supabase
      .channel("sidebar-inbox-unread")
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "chat_messages" },
        () => load(),
      )
      .on(
        "postgres_changes",
        { event: "UPDATE", schema: "public", table: "chat_conversations" },
        () => load(),
      )
      .subscribe();

    return () => {
      cancelled = true;
      supabase.removeChannel(channel);
    };
  }, []);

  return count;
}
